// Module
var code = "<div class=\"ecom-domain-selector\"> <div class=\"ecom-domain-selector__input-container\"></div> <button class=\"ecom-domain-selector__button\" type=\"button\" role=\"button\"> [[Go]] </button> </div>";
// Exports
module.exports = code;